/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Plan } from "../housien-models/SubscriptionPlan";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPIHousien } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export interface CatalogAddon {
  id: string;
  slug: string;
  display_name: Record<string, string>;
  description: Record<string, string>;
  price_cents: number;
  currency: string;
  billing_type: string;
  billing_frequency: string;
  validity_days: number | null;
  max_quantity_per_subscription: number | null;
  active: boolean;
  sort_order: number;
  /**
   * Which metered quota this addon credits. Null when the slug is not in the
   * backend's grant table.
   */
  granted_quota_type?: string | null;
  /**
   * How many units the addon grants on purchase, read from the table the quota
   * ledger actually credits. Null — not zero — when the slug is unrecognised:
   * zero would assert the pack grants nothing.
   */
  granted_quantity?: number | null;
}

/**
 * AdministrationService class.
 */
export class AdministrationService {
  /**
   * Get Plan Information
   * Returns the plan information.
   * @returns SubscriptionPlan Plan information retrieved successfully.
   * @throws ApiError
   */
  public static getSubscriptionPlans(): CancelablePromise<Plan[]> {
    return __request(OpenAPIHousien, {
      method: "GET",
      url: "/administration/plans",
    });
  }

  /**
   * Get Available Addons
   * Returns all active subscription addons from the catalog.
   * @returns CatalogAddon[] List of available addons.
   * @throws ApiError
   */
  public static getAddons(): CancelablePromise<CatalogAddon[]> {
    return __request(OpenAPIHousien, {
      method: "GET",
      url: "/administration/addons",
    });
  }
}
